
























import Vue from "vue";

export interface Field {
  key: string;
  label?: string;
  custom?: Function;
}

export default Vue.extend({
  name: "Fieldset",
  props: {
    title: {
      type: String,
      default: "",
    },
    data: {
      type: [Object, Array],
    },
    fields: {
      type: Array as () => Field[],
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    invert: {
      type: Boolean,
      default: false,
    },
  },
});
